<template>
  <div>
    <v-row>
      <v-col cols="12" class="px-4 py-2">
        <TabelaAnexos />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import TabelaAnexos from './Shared/TabelaAnexos'
export default {
  components: {
    TabelaAnexos
  },
  data() {
    return {
      // Error Handler
      error: false,
      errObj: {},
      loadingOverlay: false,
      args: ''
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
  }
}
</script>

<style scoped></style>
